<capra-toast
  type="success"
  [inline]="true"
  [showCloseBtn]="true"
  [canTapToDismiss]="false"
  (dismissToast)="dismissToast()"
>
  <div class="report-clone-success-content">
    <p class="success-message">Your copy is ready</p>
    <capra-button-link
      class="edit-report-cta"
      [href]="clonedReportLink"
      (click)="dismissToast()"
      text="Edit Report"
      variant="secondary"
      color="neutral"
    ></capra-button-link>
  </div>
</capra-toast>
